const pageHandleFilterParams = (filterPanelData) => {
  const { sortOptions, filterOptions } = filterPanelData?.json_data || {};
  let sort_code = '';
  let sort_name = '';
  if (sortOptions) {
    sortOptions?.sortOptionValues?.forEach((item) => {
      if (item.isSelected) {
        sort_code = item.sortCode;
        sort_name = item.sortName;
      }
    });
  }
  const filter_code_array: string[] = [];
  const filter_name_array: string[] = [];
  if (filterOptions) {
    filterOptions.forEach((filterOption) => {
      filterOption.filterOptionValues.forEach((item) => {
        if (item.isSelected) {
          filter_code_array.push(item.filterId);
          filter_name_array.push(item.filterDisplayName);
        }
      });
    });
  }
  const filter_code = filter_code_array.join(';');
  const filter_name = filter_name_array.join(';');
  const lxFilterParams = {
    sort_code,
    sort_name,
    filter_code,
    filter_name,
  };
  return lxFilterParams;
};

export const SLPreloadBizSailorCAPP = 'sailor_c_app';
export const SLPreloadBizKFood = `${SLPreloadBizSailorCAPP}_kfood`;

export { pageHandleFilterParams };
